import { render } from "./Show.vue?vue&type=template&id=3e313edc&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=3e313edc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e313edc"

export default script